module.exports = __webpack_public_path__ + "static/media/download-icon.928d9a67.svg";